import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[integerOnly]'
})
export class IntegerOnly  {
    @Input() allowNegative: boolean;

    @Input() min: number;

    @Input() max: number;

    constructor(private el: ElementRef) {
        this.allowNegative = true;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
        const pattern = /^[-,+]?[0-9]*/;
        /**
         * Allow backspace,left,right and delete
         */
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode == 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode == 88 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        // Ensure that it is a number and is in range
        if (!pattern.test(e.key) || !this.isInRange(e.key)) {
            e.preventDefault();
        }
    }

    private isInRange(key: string) {
        let isValid: boolean;
        /**
         * Handling negative condition
         */
        if (this.el.nativeElement.value.length == 0 && key == '-') {
            return !this.min || this.min < 0;
        }
        const numb = +(this.el.nativeElement.value + key);
        isValid = !this.min || numb >= this.min;
        isValid = isValid && (!this.max || numb <= this.max);
        return isValid;
    }
}
